import { render, staticRenderFns } from "./StarRatingIcon.vue?vue&type=template&id=1e1b8166"
import script from "./StarRatingIcon.vue?vue&type=script&lang=js"
export * from "./StarRatingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports